import NavBar from "../../components/NavBar/NavBar"
import Footer from "../../components/Footer/Footer"
import CircleCard from "../../components/Circle-Card/Circle-Card"
import Title from '../../components/Title/Title'

export default function Relics() {
    return (
        <div>
            <NavBar/>
   
            <Title text={"O que São Relíquias?"}/>
            <p className="info-text">
            Segundo o Código de Direito Canônico (1983), relíquias são definidos como “o que resta do corpo, dos vestidos ou dos objetos que pertenceram a um santo ou a um beato”[1]. <br/>
            Ou seja, qualquer fragmento físico – ossos, cabelos, vestes ou objetos – que tenha relação direta com a pessoa de um santo. 
            A doutrina católica sustenta que o corpo dos santos, destinado à ressurreição, foi “sobre a terra o templo vivo do Espírito Santo e o instrumento da sua santidade”[2]. 
            Por isso, recebeu sempre veneração especial: os cristãos veneram essas relíquias não como se tivessem em si mesmos algum poder mágico, mas para honrar a santidade dos corpos glorificados e a Deus, por meio dos santos. 
            O Concílio de Trento (1563) reiterou que os fiéis devem 
            venerar os corpos dos mártires e outros santos que agora vivem com Cristo, reconhecendo que disso provêm “muitos benefícios concedidos por Deus aos homens”[3]. 
            Porém, Trento também advertiu que, nesse culto, “toda superstição deverá ser removida e toda blasfema busca de lucro (simonia) abolida”[4], proibindo assim abusos e comércio ilícito.
            </p>

            <Title text={"Sobre a Veneração de Relíquias"}/>
            <p className="info-text">
            São Tomás de Aquino, na Suma Teológica, aborda essa prática na Terceira Seção, Questão 25, Artigo 6, onde destaca que não é apenas a devoção dos fiéis que honra as relíquias, mas é o próprio Deus quem as honra, realizando milagres na presença delas. 
            Esses milagres são um testemunho visível da aprovação divina às relíquias e à veneração dos santos. 
            A relíquia não faz milagres nem é uma prática supersticiosa. 
            Contudo, Deus, reconhecendo os seus santos, faz milagres pela intercessão deles, muitas vezes associados à veneração de suas relíquias — como já aconteceu inúmeras vezes.
            </p>

            <p className="info-text">
                Vemos também, nas Sagradas Escrituras, no Segundo Livro dos Reis, o relato da ressureição de um homem, após o contato com as relíquias do profeta Eliseu.<br/>
                "Ora, aconteceu que um grupo de pessoas, estando a enterrar um homem, viu uma turma desses guerrilheiros e jogou o cadáver no túmulo de Eliseu. 
                O morto, ao tocar os ossos de Eliseu, voltou à vida e pôs-se de pé." [IIReis 13, 21]
            </p>

            <p className="info-text">
                Referente a veneração das vestimentas ou objetos de devoção, encontramos também um caso no Novo Testamento: <br/>
                "Deus fazia milagres extra­or­dinários por intermédio de Paulo, de modo que lenços e outros panos que tinham tocado o seu corpo eram levados aos enfermos; e afastavam-se deles as doenças e retiravam-se os espíritos malignos." [At 19, 11-12]
            </p>
        
        <Title text={"Graus de Relíquias"}/>
        <p className="info-text">
        <strong>Relíquias de Primeiro Grau:</strong><br/>
        São constituídas pelas partes do corpo do beato ou santo. Sangue, cabelo, pele, etc<br/>
        São vistas como as "Mais Valiosas", por isso Primeiro Grau.<br/> 
        </p>
        

        <p className="info-text">
        <strong>Relíquias de Segundo Grau:</strong><br/>
        É algo que pertenceu ao santo, que o tocou o que ele utilizou, como terços, sapatos, roupas.
        Essas relíquias, além de servirem para a veneração, mostram para nós, testemunhos visíveis da sua vida e devoção a Deus.
        </p>
        
 
        <p className="info-text">
        <strong>Relíquias de Terceiro Grau ou Lembrança:</strong><br/>
        São objetos pessoais, percetencentes aos fiéis e que são tocados, ou encostados nos túmulos dos santos.<br/>
        Portanto, ao contrário dos dois tipos anteriores, essas não possuem nenhuma conexão direta com seu corpo.
        Ou seja, terços, panos, e outros objetos, quando tocados no local do sepultamento, tornam-se relíquias sagradas. <br/> 
        </p>
        <Footer/>
        </div>
    )
}